export default defineNuxtPlugin(() => {
  const unleashClient = getUnleashClient()
  const discountStore = useDiscountStore()
  const { discountStorage } = useDiscountStorage()
  const isGlobalCouponEnabled = unleashClient.isEnabled('storefront.global-coupons')

  if (discountStorage.value.code && isGlobalCouponEnabled) {
    discountStore.applyCoupon(discountStorage.value.code)
  }
})
